import { compareVersion } from '../compare-version';
import { PusherService } from './index';

const MINIMUM_WORKSTATION_VERSION_NUMBER = '4.2.0';

export const WorkStationChannelHelpers = {
  enableWorkstationChannelBypass: false,
  setEnableWorkstationChannelBypass(enable) {
    this.enableWorkstationChannelBypass = enable;
  },
  workstationShouldUseOwnChannel(workstation) {
    const version = workstation.version || '0.0.0';
    return compareVersion(version, MINIMUM_WORKSTATION_VERSION_NUMBER) >= 0;
  },
  getUseOwnChannelNameWorkstations(workstations) {
    if (this.enableWorkstationChannelBypass) {
      return [];
    }
    const channelNames = workstations
      .map((workstation) => {
        const { workstationId } = workstation;
        const shouldUseOwnChannel = this.workstationShouldUseOwnChannel(workstation);
        if (!shouldUseOwnChannel) {
          return;
        }
        const channelName = PusherService.getWorkstationChannelName(workstationId);
        const isSubscribed = PusherService.getIsChannelSubscribed(channelName);
        if (isSubscribed) {
          return;
        }
        return channelName;
      })
      .filter((name) => !!name);

    return channelNames;
  },
};
const workstationShouldUseOwnChannel = (workstation) => {
  const version = workstation.version || '0.0.0';
  return compareVersion(version, MINIMUM_WORKSTATION_VERSION_NUMBER) >= 0;
};

export const getUseOwnChannelNameWorkstations = (workstations) => {
  const channelNames = workstations
    .map((workstation) => {
      const { workstationId } = workstation;
      const shouldUseOwnChannel = workstationShouldUseOwnChannel(workstation);
      if (!shouldUseOwnChannel) {
        return;
      }
      const channelName = PusherService.getWorkstationChannelName(workstationId);
      const isSubscribed = PusherService.getIsChannelSubscribed(channelName);
      if (isSubscribed) {
        return;
      }
      return channelName;
    })
    .filter((name) => !!name);

  return channelNames;
};

export const ChannelAuthorizationHelpers = {
  channelSocketSet: new Set(),
  checkHasDoneInitialAuth(channelSocketName) {
    const hasDoneInitialAuth = this.channelSocketSet.has(channelSocketName);
    this.channelSocketSet.add(channelSocketName);
    return hasDoneInitialAuth;
  },
  buildChannelSocketName(channelName, pusherAppKey) {
    // use pusherAppKey instead of socketId because
    // the socketId changes everytime the network connection drops
    return `${channelName}-${pusherAppKey}`;
  },
  removeChannelSocketName(channelSocketName) {
    this.channelSocketSet.delete(channelSocketName);
  },
};
